import React from 'react';

const PAGE_SIZE = 50;

export type PaginationProps = {
  startIdx: number;
  endIdx: number;
  count: number;
  dateLength: number;
  page: number;
  setPage?: (page: number) => void;
};

const Pagination = (props: PaginationProps) => {
  const { startIdx, endIdx, count, dateLength, page, setPage } = props;

  return (
    <div style={styles.paginationContainerStyle}>
      <button
        disabled={page === 0}
        onClick={() => {
          if (setPage) setPage(Math.max(page - 1, 0));
        }}
        style={{
          ...styles.paginationButtonStyle,
          ...(page === 0 ? styles.disabledButtonStyle : {}),
        }}>
        Previous
      </button>
      <span style={styles.paginationTextStyle}>
        Showing {startIdx} - {endIdx} of {count}
      </span>
      <button
        disabled={dateLength < PAGE_SIZE}
        onClick={() => {
          if (setPage) setPage(page + 1);
        }}
        style={{
          ...styles.paginationButtonStyle,
          ...(dateLength < PAGE_SIZE ? styles.disabledButtonStyle : {}),
        }}>
        Next
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  paginationContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px', // Add spacing between buttons and text
    marginTop: '16px', // mt-4
  } as React.CSSProperties,
  paginationButtonStyle: {
    padding: '4px 12px', // px-3 py-1
    backgroundColor: '#e5e7eb', // bg-gray-200
    borderRadius: '4px', // rounded
    border: 'none',
    cursor: 'pointer',
  } as React.CSSProperties,
  disabledButtonStyle: {
    backgroundColor: '#f3f4f6', // bg-gray-100 for better contrast
    color: '#9ca3af', // text-gray-400 for a more standard disabled look
    cursor: 'not-allowed',
  } as React.CSSProperties,
  paginationTextStyle: {
    margin: '0 8px', // Add margin to keep text close to buttons
  } as React.CSSProperties,
};

export default Pagination;
